export default __webpack_public_path__ + "static/media/Office01.0fa5f699.jpg";